import lodash from 'lodash'

var isArray = lodash.isArray
var isObject = lodash.isObject
var find = lodash.find
var clone = lodash.clone

/**
 * @see {@link /writer/conceptinteraction.html} for Concept interaction
 * @deprecated 2018-12-11
 */
class Concept {

    /**
     * Deprecated, use import {ConceptService} from 'writer' instead
     *
     * @param {*} definition An array or object
     * @param {string} type The type to search for, drol:short, drol:long
     * @deprecated
     * @returns {Object | undefined} Return either the definition object or undefined if not found
     */
    static getDefinitionForType(definition, type) {
        console.warn(`api.concept.getDefinitionForType is deprecated, use import {ConceptService} from 'writer' instead`)

        if (!definition) {
            return undefined;
        }
        if (isArray(definition)) {
            return find(definition, function (def) {
                return def['@role'] === type;
            });
        } else if (isObject(definition)) {
            return definition['@role'] === type ? definition : undefined;
        }

    }

    /**
     * Deprecated, use import {ConceptService} from 'writer' instead
     *
     * @param {Object | Object[]} definition - An array or object
     * @param {Object} description - object
     * @deprecated
     * @returns {*}
     */
    static setDefinitionDependingOnArrayOrObject(definition, description) {
        console.warn(`api.concept.setDefinitionDependingOnArrayOrObject is deprecated, use import {ConceptService} from 'writer' instead`)

        if (isArray(definition)) {
            definition.push(description);
            return definition;
        } else {
            var existingDescription = clone(definition);
            definition = [];
            definition.push(existingDescription);
            definition.push(description);
            return definition;
        }
    }

}

export {Concept}
